import { render, staticRenderFns } from "./MenuSettingsModal.vue?vue&type=template&id=7d410f80&scoped=true&"
import script from "./MenuSettingsModal.vue?vue&type=script&lang=js&"
export * from "./MenuSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./MenuSettingsModal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MenuSettingsModal.vue?vue&type=style&index=1&id=7d410f80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d410f80",
  null
  
)

/* custom blocks */
import block0 from "./MenuSettingsModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCardTitle,VDialog,VDivider,VFileInput,VForm,VIcon,VSwitch,VTab,VTabItem,VTabs,VTabsItems,VTooltip})
